import { Button, ButtonProps, darken, styled } from '@mui/material';

export const PartsButton = styled(Button)<ButtonProps>(({ theme }) => ({
  boxSizing: 'border-box',
  color: theme.palette.getContrastText(theme.palette.common.white),
  backgroundColor: theme.palette.common.white,
  justifyContent: 'space-between',
  textAlign: 'left',
  '&:hover': {
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: darken(theme.palette.common.white, 0.025),
  },
  boxShadow: theme.customShadows.z16,
}));

export const PartsSelectedButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.getContrastText(theme.palette.grey[600]),
  backgroundColor: theme.palette.grey[600],
  justifyContent: 'space-between',
  textAlign: 'left',
  '&:hover': {
    border: `2px solid ${theme.palette.error.main}`,
    backgroundColor: darken(theme.palette.grey[600], 0.025),
  },
  boxShadow: theme.customShadows.z16,
}));
